var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "h-100" },
    [
      _vm.yandexMetrikaId
        ? _c("YandexMetrika", { attrs: { "counter-id": +_vm.yandexMetrikaId } })
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.$store.getters.getMaintenanceMode
          ? _c("div", { staticClass: "maintenance-mode-wrapper" }, [
              _c("div", { staticClass: "w-75" }, [
                _c("p", [
                  _vm._v(
                    "Сервис обновляется... Работа по обновлению, как правило, занимает до 15 минут."
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "The service is being updated ... Updating usually takes up to 15 minutes."
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_vm.language ? _c("router-view") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "scroll-btn" }, [
      _c("i", { staticClass: "flaticon-up-arrow" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }